const DEV = process.env.NODE_ENV === "development";
 
const isAbsolute = (url) => /^https?:\/\//.test(url || "");
 
// keep in sync with PROXIES in src/setupProxy.js
const resolve = (url, devPath) => (DEV && isAbsolute(url) ? devPath : url);
 
export const AUTH_BASEURL_V1 = resolve(process.env.REACT_APP_AUTH_BASEURL_V1, "/proxy/auth");
export const MODEL_BASEURL_V1 = resolve(process.env.REACT_APP_MAPPER_MODEL_BASEURL_V1, "/proxy/model");